<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-hardware-server`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 4a2 2 0 00-1.696.94l-5 8A2 2 0 004 14v28a2 2 0 002 2h36a2 2 0 002-2V14a2 2 0 00-.304-1.06l-5-8A2 2 0 0037 4H11zm27.392 8H9.608l2.5-4h23.784l2.5 4zM8 16h32v10H8V16zm0 14v10h32V30H8zm23-11h6v4h-6v-4zm0 14h6v4h-6v-4z"/></svg>
</template>
<script>

export default {
  name: 'IconHardwareServer',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
